
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiBuoyPilarSphere as ObiBuoyPilarSphereElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-buoy-pilar-sphere.js';
 
 
 

 
 export const ObiBuoyPilarSphere = createComponent({
   react: React,
   tagName: 'obi-buoy-pilar-sphere',
   elementClass: ObiBuoyPilarSphereElement,
   events: {
     
   }
  });
 
 